(() => {
  const STYLE_ID='cpb-description-accordion-style';
  const labels=window.cpbAccordion||{showMore:'Show more',showLess:'Show less'};

  if(!document.getElementById(STYLE_ID)){
    const s=document.createElement('style');
    s.id=STYLE_ID;
    s.textContent=`
      #product-builder .cpb-desc-preview{margin:16px 0 0}
      #product-builder .cpb-desc-preview-clip{position:relative;overflow:hidden;transition:height .4s cubic-bezier(.4,0,.2,1)}
      #product-builder .cpb-desc-preview-clip:not(.is-open)::after{content:"";position:absolute;left:0;right:0;bottom:0;height:1.8em;pointer-events:none;background:linear-gradient(to bottom,rgba(255,255,255,0),#fff)}
      #product-builder .cpb-desc-preview .cpb-product-description{margin:0!important}
      #product-builder .cpb-product-description,#product-builder .cpb-product-description *,#product-builder .cpb-desc-preview-more{font-size:clamp(14px,calc(12.664px + .334vw),16px)!important}
      #product-builder .cpb-desc-preview-more{display:inline-block;margin:12px 0 0;padding:0;border:0;background:transparent;color:inherit;font-family:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer}
      @media(max-width:999px){#product-builder .cpb-desc-preview{margin-bottom:16px}}
    `;
    document.head.appendChild(s);
  }

  function init(){
    const d=document.querySelector('#product-builder .cpb-product-description');
    if(!d||d.closest('.cpb-desc-preview')) return;

    const wrap=document.createElement('div');
    wrap.className='cpb-desc-preview';

    const clip=document.createElement('div');
    clip.className='cpb-desc-preview-clip';

    const button=document.createElement('button');
    button.type='button';
    button.className='cpb-desc-preview-more';
    button.textContent=labels.showMore;

    d.parentNode.insertBefore(wrap,d);
    clip.appendChild(d);
    wrap.append(clip,button);

    let open=false;

    const collapsedHeight=()=>{
      const cs=getComputedStyle(d);
      let lh=parseFloat(cs.lineHeight);
      if(!lh) lh=(parseFloat(cs.fontSize)||16)*1.5;
      return Math.round(lh*(window.innerWidth<=999?2:3));
    };

    const update=()=>{
      if(!open) clip.style.height=collapsedHeight()+'px';
    };

    update();

    requestAnimationFrame(()=>{
      if(d.scrollHeight<=collapsedHeight()+2){
        clip.style.height='auto';
        clip.classList.add('is-open');
        button.hidden=true;
      }
    });

    button.addEventListener('click',()=>{
      if(!open){
        clip.style.height=clip.getBoundingClientRect().height+'px';
        clip.classList.add('is-open');
        clip.offsetHeight;
        clip.style.height=clip.scrollHeight+'px';
        button.textContent=labels.showLess;
        open=true;

        const done=e=>{
          if(e.propertyName!=='height') return;
          clip.style.height='auto';
          clip.removeEventListener('transitionend',done);
        };
        clip.addEventListener('transitionend',done);
      }else{
        clip.style.height=clip.scrollHeight+'px';
        clip.offsetHeight;
        clip.style.height=collapsedHeight()+'px';
        clip.classList.remove('is-open');
        button.textContent=labels.showMore;
        open=false;
      }
    });

    window.addEventListener('resize',update);
  }

  const observer=new MutationObserver(init);
  observer.observe(document.documentElement,{childList:true,subtree:true});
  init();
})();